import React from 'react';
import { Box, Grid, Typography, Divider } from '@mui/material';
import ActiveGlobalMessage from './ActiveGlobalMessage';
import StoreSpecificMessages from './StoreSpecificMessages';
import PushNotificationPanel from './PushNotificationPanel';
import MessageHistory from './MessageHistory';

/**
 * Store Messages Manager
 *
 * Redesigned to match original system UX:
 * 1. Active Global Message - ONE prominent message shown on all phones
 * 2. Store-Specific Messages - List of active store messages
 * 3. Push Notifications - One-time push notifications (doesn't persist)
 * 4. Message History - Closed/expired messages only
 */
const StoreMessagesManager: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        💬 Store Messages & Notifications
      </Typography>

      {/* Section 1: Active Global Message */}
      <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2, color: '#1976d2' }}>
        📨 In-App Messages (Socket.IO)
      </Typography>

      <Grid container spacing={3}>
        <Grid size={12}>
          <ActiveGlobalMessage />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* Section 2: Store-Specific Messages */}
      <Grid container spacing={3}>
        <Grid size={12}>
          <StoreSpecificMessages />
        </Grid>
      </Grid>

      <Divider sx={{ my: 4 }} />

      {/* Section 3: Push Notifications */}
      <Typography variant="h6" gutterBottom sx={{ mb: 2, color: '#1976d2' }}>
        📱 Push Notifications (Firebase)
      </Typography>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 8 }}>
          <PushNotificationPanel />
        </Grid>
      </Grid>

      <Divider sx={{ my: 4 }} />

      {/* Section 4: Message History */}
      <Grid container spacing={3}>
        <Grid size={12}>
          <MessageHistory />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StoreMessagesManager;
